export const HEADLINE_CUTOFFS = {
  LARGE: 194,
  MEDIUM: 174,
  SMALL: 134,
  XS: 70,
}

export const DESCRIPTION_CUTOFFS = {
  LARGE: 207,
  MEDIUM: 207,
  SMALL: 144,
}
